/**
 * A ficha do evento (metadata) às vezes chega da API como texto JSON em vez de objeto. Os
 * formulários leem e reescrevem sempre um objeto: espalhar o texto criaria uma chave por
 * caractere, e é isso que seria salvo de volta.
 */

const ehObjetoDeFicha = (valor: unknown): valor is Record<string, unknown> =>
  typeof valor === 'object' && valor !== null && !Array.isArray(valor);

const fichaDoTexto = (texto: string): Record<string, unknown> | null => {
  try {
    const convertida: unknown = JSON.parse(texto);
    return ehObjetoDeFicha(convertida) ? convertida : null;
  } catch {
    return null;
  }
};

/** A ficha como os formulários precisam dela: objeto, ou nada quando não descreve um objeto */
export function fichaComoObjeto(ficha: unknown): Record<string, unknown> | null {
  if (typeof ficha === 'string') return fichaDoTexto(ficha);
  return ehObjetoDeFicha(ficha) ? ficha : null;
}
